import React, { useContext, useState } from "react";
import {
  Box,
  Button,
  Modal,
  Typography,
  CircularProgress,
} from "@mui/material";
import PropertyContext from "../contexts/PropertyContext";
import generatePropertyIssuesPDF from "./generatePropertyIssuesPDF";
import { firestore } from "../firebase";

const FacilitiesReports = ({ user }) => {
  const [selectedReport, setSelectedReport] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");

  const { selectedProperty, selectedClient, rooms } = useContext(PropertyContext);

  const handleGeneratePropertyIssuesPDF = async () => {
    setStatusMessage("Starting Property Issues Report generation...");
    setIsGenerating(true);
    await generatePropertyIssuesPDF(selectedClient, selectedProperty, setStatusMessage, user);
    setIsGenerating(false);
  };

  const generateFacilitiesOverviewReport = async () => {
    setStatusMessage("Generating Facilities Overview Report...");
    console.log(`Generating Facilities Overview Report`);
    setStatusMessage("Facilities Overview Report generated successfully.");
    setIsGenerating(false);
  };

  const generateMaintenanceScheduleReport = async () => {
    setStatusMessage("Generating Maintenance Schedule Report...");
    console.log(`Generating Maintenance Schedule Report`);
    setStatusMessage("Maintenance Schedule Report generated successfully.");
    setIsGenerating(false);
  };

  const generateVendorPerformanceReport = async () => {
    setStatusMessage("Generating Vendor Performance Report...");
    console.log(`Generating Vendor Performance Report`);
    setStatusMessage("Vendor Performance Report generated successfully.");
    setIsGenerating(false);
  };

  const generatePropertyComplianceReport = async () => {
    setStatusMessage("Generating Property Compliance Report...");
    console.log(`Generating Property Compliance Report`);
    setStatusMessage("Property Compliance Report generated successfully.");
    setIsGenerating(false);
  };

  const generateCostAnalysisReport = async () => {
    setStatusMessage("Generating Cost Analysis Report...");
    console.log(`Generating Cost Analysis Report`);
    setStatusMessage("Cost Analysis Report generated successfully.");
    setIsGenerating(false);
  };

  const generateWorkOrderSummaryReport = async () => {
    setStatusMessage("Generating Work Order Summary Report...");
    console.log(`Generating Work Order Summary Report`);
    setStatusMessage("Work Order Summary Report generated successfully.");
    setIsGenerating(false);
  };

  const handleGenerate = () => {
    setIsGenerating(true);
    switch (selectedReport) {
      case "facilities overview report":
        generateFacilitiesOverviewReport();
        break;
      case "maintenance schedule report":
        generateMaintenanceScheduleReport();
        break;
      case "vendor performance report":
        generateVendorPerformanceReport();
        break;
      case "property compliance report":
        generatePropertyComplianceReport();
        break;
      case "cost analysis report":
        generateCostAnalysisReport();
        break;
      case "work order summary report":
        generateWorkOrderSummaryReport();
        break;
      case "property issues report":
        handleGeneratePropertyIssuesPDF();
        break;
      default:
        console.log("No report selected: ", selectedReport);
        setIsGenerating(false);
        break;
    }
  };

  return (
    <Box display="flex" alignItems="center" flexDirection="column">
      <Box marginBottom="4rem">
        <Typography variant="h4">Facilities Reports</Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {[
          "facilities overview report",
          "maintenance schedule report",
          "vendor performance report",
          "property compliance report",
          "cost analysis report",
          "work order summary report",
          "property issues report",
        ].map((item) => (
          <Box key={item}>
            <Button
              variant={selectedReport === item ? "contained" : "outlined"}
              onClick={() => setSelectedReport(item)}
              sx={{ minWidth: 250, textTransform: 'capitalize' }}
            >
              {item}
            </Button>
          </Box>
        ))}

        {selectedReport !== null && (
          <Button
            variant="contained"
            color="primary"
            onClick={handleGenerate}
            sx={{ mt: 2 }}
          >
            Generate Report
          </Button>
        )}
      </Box>

      <Modal open={isGenerating}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="100vh"
          bgcolor="background.paper"
          padding="2rem"
          borderRadius="8px"
        >
          <Typography variant="h6" gutterBottom>
            Generating Report
          </Typography>
          <CircularProgress />
          <Typography variant="body1" marginTop="1rem">
            {statusMessage}
          </Typography>
        </Box>
      </Modal>
    </Box>
  );
};

export default FacilitiesReports;